import { render, staticRenderFns } from "./NewsIndex.vue?vue&type=template&id=61870d18&scoped=true&"
import script from "./NewsIndex.vue?vue&type=script&lang=js&"
export * from "./NewsIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewsIndex.vue?vue&type=style&index=0&id=61870d18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61870d18",
  null
  
)

export default component.exports